import * as mqqAPI from "../../api/mqq"
import { getUserAgent } from "../../utils/ua"

interface shareInfo {
  title: string
  desc: string
  img: string
  url: string
}

export function share(context: shareInfo): void {
  function wechatShare(type) {
    return () => {
      WeixinJSBridge.invoke(
        type,
        {
          appid: "wx951bdcac522929b6",
          img_url: (() => {
            return context.img
          })(),
          img_width: "240",
          img_height: "240",
          link: (() => {
            return context.url
          })(),
          desc: (() => {
            return context.desc
          })(),
          title: (() => {
            return context.title
          })()
        },
        () => {
          //alert(res.err_msg);
        }
      )
    }
  }

  function init() {
    WeixinJSBridge.on("menu:share:appmessage", wechatShare("sendAppMessage")) // 监听发送好友事件
    WeixinJSBridge.on("menu:share:timeline", wechatShare("shareTimeline")) // 监听朋友圈分享事件
    WeixinJSBridge.on("menu:share:qq", wechatShare("shareQQ")) // 监听微信分享手Q
  }

  if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    init()
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", init, false)
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", init)
      document.attachEvent("onWeixinJSBridgeReady", init)
    }
  }

  if (getUserAgent().QQ) {
    mqqAPI.setOnMqqShareHandler(type => {
      return {
        type,
        title: context.title,
        desc: (() => {
          return context.desc
        })(),
        img: (() => {
          return context.img
        })(),
        url: (() => {
          return context.url
        })()
      }
    })
  }
}
